<template>
  <!-- <div class="banner-principal">
    <div class="banner-principal-content">
      <div class="banner-principal-logo-rte">
        <img src="../../assets/images/logo-rte.png" alt="Logo RTE" />
      </div>
      <div>
        <img src="../../assets/images/logo-econet-2.png" alt="Logo econet" />
      </div>
    </div>
  </div> -->
  <div class="banner-principal">
    <div class="banner-principal-content">
      <div class="banner-principal-logo-rte">
        <img src="../../assets/images/logo-rte.png" alt="Logo RTE" />
      </div>
      <div class="banner-principal-mensagem">
        <div class="banner-principal-texto-1">
          Revisor Tributário Econet
        </div>
        <div class="banner-principal-texto-2">
          Transforme a sua rotina tributária
        </div>
      </div>
      <div class="banner-principal-logo-econet">
        <img src="../../assets/images/logo-econet.svg" alt="frase banner" />
      </div>
    </div>
    <div class="teste"></div>
    <div class="imagem-banner-fundo"></div>
  </div>
</template>

<script>
export default {
  name: "BannerPrincipal"
};
</script>

<style lang="scss" scoped>
.banner-principal {
  height: 200px;
  width: 100%;
  // background: red;
  // background-image: url("../../assets/images/background.png");
  background-image: url("../../assets/images/background-offwhite.svg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.banner-principal-content {
  width: 100%;
  height: 100%;
  max-width: 1155px;
  padding: 0 30px 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background: red;
}
.banner-principal-logo-econet {
  z-index: 10;
  // margin-top: 10px;
  margin-right: 100px;

  // position: absolute;
  // right: 160px;
  // top: 60px;
  // margin-right: 450px;

  // height: 50px;
  img {
    width: 200px;
  }
}
.banner-principal-mensagem {
  z-index: 10;
  margin-top: 10px;
  font-family: "Montserrat", sans-serif;
  user-select: none;
  // height: 50px;
  // line-height: 23px;
  // img {
  //   width: 300px;
  // }
  .banner-principal-texto-1 {
    font-size: 17px;
    font-weight: 700;
    color: #098cce;
  }
  .banner-principal-texto-2 {
    font-weight: 500;
    font-size: 15px;
    color: #65659d;
  }
}
.banner-principal-logo-rte {
  z-index: 10;
  // height: 50px;
  padding-bottom: 10px;
  img {
    width: 250px;
  }
}
.imagem-banner-fundo {
  position: absolute;
  right: 0;
  top: 0;
  background-image: url("../../assets/images/rte-background-image.png");
  background-size: contain;
  background-position: right;
  height: 100%;
  width: 500px;
}

@media only screen and (max-width: 1920px) {
  .banner-principal-logo-econet {
    margin-right: calc( 100% - 52vw);
  }
}
@media only screen and (max-width: 1600px) {
  .banner-principal-logo-econet {
    margin-right: calc( 100% - 54vw);
  }
}
@media only screen and (max-width: 1400px) {
  .banner-principal-mensagem {
    display: none;
  }
  .banner-principal-logo-econet {
    margin-right: calc( 100% - 50vw);
  }
}
</style>
